<div id="syndicate_profile_create">
  @if (step === 1) {
  <div class="w-full content widget captain-create">
    <div class="component-header-row">
      <div class="widget-header">
        <span [transloco]="'profile.CREATE_TITLE'"></span>
      </div>
    </div>
    <div class="captain-create__content">
      <div class="text-14">
        <span [transloco]="'profile.CREATE_SUBTITLE'"></span>
      </div>
    </div>
    <div class="captain-create__inputs">
      <span class="input-icon">
        <i class="fal fa-user-circle text-16" aria-hidden="true"></i>
      </span>
      <input
        class="text icon-before"
        [(ngModel)]="defaultManager.username"
        placeholder="{{'profile.NAME_PLACEHOLDER' | transloco}}"
        maxlength="15"
        [disabled]="defaultManager.id"
        #username
      />
    </div>

    <div class="captain-create__actions">
      @if (!defaultManager.id) {
      <a class="btn primary w-button _48" (click)="createManager()" [ngClass]="{'pointer-events-none opacity-50': imageBlocked}">
        <span [transloco]="'buttons.CREATE_PROFILE'"></span>
      </a>
      }
      <a class="btn tertiary w-button _48" (click)="cancelCreate()">
        <span [transloco]="'buttons.CANCEL'"></span>
      </a>
    </div>

    @if (error) {
    <div class="captain-create__errors">
      <div class="error">
        <span
          [transloco]="'errors.MANAGER_' + error"
          [translocoParams]="{defaultValue: ('errors.MANAGER_UNKNOWN'|transloco)}"
        ></span>
      </div>
    </div>
    }
  </div>
  } @if (step === 2) {
  <div class="w-full content widget captain-create">
    <div class="component-header-row">
      <div class="widget-header">
        <span [transloco]="'profile.SUCCESS'"></span>
      </div>
    </div>
    <div class="captain-create__content">
      <div class="text-14">
        <span [transloco]="'profile.UPDATE_TITLE'"></span>
      </div>
    </div>

    <div
      class="captain-create__image-list"
      [ngClass]="{'cropping': isCropping }"
    >
      @if (!showSelector) {
      <div class="profile_img_content">
        <div class="flex flex-row justify-center items-center">
          <span
            class="image-placeholder"
            (click)="showSelector = !showSelector"
          >
            @if (!showSelector) {
            <div class="edit-image">
              <i class="text" [transloco]="'avatar.EDIT'"></i>
            </div>
            }
            <img
              [src]="defaultManager.picture_url"
              loading="lazy"
              imgLazyLoad
              (error)="setFallbackImage()"
              alt=""
            />
          </span>
        </div>
      </div>
      } @if (showSelector) {
      <div class="image-customizer">
        <div class="segmented-control w-tab-menu reverse mb-4">
          <a
            class="tab-link w-inline-block reverse"
            (click)="setViewList(false)"
            [ngClass]="{'w--current' : !viewList}"
          >
            <span [transloco]="'avatar.UPLOAD_IMAGE'"></span>
          </a>
          <a
            class="tab-link w-inline-block reverse"
            (click)="setViewList(true)"
            [ngClass]="{'w--current' : viewList}"
          >
            <span [transloco]="'avatar.SELECT_IMAGE'"></span>
          </a>
        </div>

        @if (viewList) {
        <div class="flex flex-row w-full overflow-x-auto">
          @for (image of imageList; track image) {
          <a
            class="image-link"
            (click)="selectImage(image, true)"
            [ngClass]="{'ring-opacity-50': image === defaultManager.picture_url}"
          >
            <img [src]="image" class="preset-avatar" alt="" />
          </a>
          }
        </div>
        <div class="flex flex-row w-full">
          <span [transloco]="'profile.SCROLL_MSG'"></span>
        </div>
        } @if (!viewList) {
        <div class="image-list">
          <avatar-uploader
            (isCropping)="manageCropping($event)"
            (fileDetected)="setCroppedImage($event)"
            (fileError)="avatarError = $event"
            class="w-full"
          ></avatar-uploader>
        </div>
        }
      </div>
      }
    </div>

    <div class="captain-create__actions centered">
      @if (!showSelector) {
      <a class="btn primary w-button _48" (click)="updateManager()" [ngClass]="{'pointer-events-none opacity-50': imageBlocked}">
        <span [transloco]="'buttons.CONFIRM'"></span>
      </a>
      } @if (showSelector) {
      <a class="btn tertiary w-button _48" (click)="showSelector = false">
        <span [transloco]="'buttons.CANCEL'"></span>
      </a>
      }
    </div>
  </div>
  }
</div>
